import {
  Control,
  FieldErrors,
  UseFormRegister,
  Controller,
} from "react-hook-form";
import { Input } from "~/components/ui";
import { TCreateJSA } from "../types";
import { cn } from "~/lib/utils";
import { FormSelectInput, FormDateInput } from "~/components/form-inputs";

interface HeaderStepProps {
  control: Control<TCreateJSA>;
  errors: FieldErrors<TCreateJSA>;
  register: UseFormRegister<TCreateJSA>;
}

const HeaderStep = ({ control, errors, register }: HeaderStepProps) => {
  return (
    <div className="space-y-6 rounded-xl border border-neutral-200 bg-white p-8">
      <h2 className="text-lg font-Medium text-primary-500">Job Details</h2>
      <div className="grid grid-cols-2 gap-6">
        <div className="space-y-2">
          <label className="text-sm font-medium">
            Title<span className="text-destructive ml-1">*</span>
          </label>
          <Input
            {...register("title")}
            placeholder="Enter Job Title"
            className={cn(errors.title && "border-destructive")}
          />
          {errors.title?.message && (
            <p className="text-destructive text-sm">
              {errors.title.message.toString()}
            </p>
          )}
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium">Reference</label>
          <Input
            {...register("reference")}
            readOnly
            className="bg-neutral-100 cursor-not-allowed text-neutral-500"
          />
        </div>

        <div className="col-span-2 space-y-2">
          <label className="text-sm font-medium">Job Description</label>
          <Input
            {...register("jobDescription")}
            placeholder="Describe the overall job"
          />
        </div>

        <div className="space-y-2">
          <Controller
            control={control}
            name="siteId"
            render={({ field: { onChange, value } }) => (
              <FormSelectInput
                label="Site"
                options={[]}
                placeholder="Select Site"
                isMulti={false}
                value={value || undefined}
                onChange={onChange}
                errors={{
                  error: !!errors.siteId,
                  message: errors.siteId?.message?.toString(),
                }}
              />
            )}
          />
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium">Work Location</label>
          <Input
            {...register("workLocation")}
            placeholder="e.g., Boiler Room B"
          />
        </div>

        <div className="space-y-2">
          <Controller
            control={control}
            name="plannedStartDate"
            render={({ field: { onChange, value } }) => (
              <FormDateInput
                label="Planned Start Date"
                value={value ? value.toISOString() : undefined}
                onChange={(val) => onChange(val ? new Date(val) : null)}
                errors={{
                  error: !!errors.plannedStartDate,
                  message: errors.plannedStartDate?.message?.toString(),
                }}
              />
            )}
          />
        </div>

        <div className="space-y-2">
          <Controller
            control={control}
            name="plannedEndDate"
            render={({ field: { onChange, value } }) => (
              <FormDateInput
                label="Planned End Date"
                value={value ? value.toISOString() : undefined}
                onChange={(val) => onChange(val ? new Date(val) : null)}
                errors={{
                  error: !!errors.plannedEndDate,
                  message: errors.plannedEndDate?.message?.toString(),
                }}
              />
            )}
          />
        </div>

        <div className="col-span-2 space-y-2">
          <label className="text-sm font-medium">Equipment Required</label>
          <Input
            {...register("equipmentRequired")}
            placeholder="List any heavy machinery or special tools"
          />
        </div>
      </div>
    </div>
  );
};

export default HeaderStep;
